<template>
  <div>
    <px-view-header title="Solicitação de cotação" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" link @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading" class="text-center">
      <px-circular-loading />
    </div>
    <div v-if="!loading && solicitacao">
      <px-cotacao-conjunta-detalhes-header :solicitacao="solicitacao"
                                           :id-cotacao="id"
                                           :municipios="municipios"
                                           @update="update"/>
      <px-cotacao-conjunta-detalhes-produtos class="mt-3" :solicitacao="solicitacao" />
      <px-cotacao-conjunta-negociacao class="mt-3"
                                      v-if="solicitacao.respostaCotacaoConjunta"
                                      :is-finalizada="isFinalizada"
                                      :id-cotacao="id"
                                      :solicitacao="solicitacao" />
    </div>
  </div>
</template>

<script>
import { SituacaoCotacao } from 'px-business-components';
import SolicitacaoService from '@/modules/cotacoes/detalhes/solicitacao-service';
import CotacaoConjuntaDetalhesHeader from './CotacaoConjuntaDetalhesHeader.vue';
import CotacaoConjuntaDetalhesProdutos from './CotacaoConjuntaDetalhesProdutos.vue';
import CotacaoConjuntaNegociacao from './negociacao/CotacaoConjuntaNegociacao.vue';

const FINALIZADAS = [SituacaoCotacao.keys.FINALIZADA.key,
  SituacaoCotacao.keys.CANCELADA.key];

export default {
  data() {
    return {
      id: this.$route.params.id,
      solicitacao: null,
      municipios: [],
      loading: false,
      breadcrumbs: [
        { text: 'Negócios' },
        { text: 'Cotações' },
      ],
    };
  },
  computed: {
    isFinalizada() {
      return FINALIZADAS.includes(this.solicitacao.cotacaoConjunta.situacao);
    },
  },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },
    getSolicitacao() {
      this.loading = true;
      return SolicitacaoService.getSolicitacao(this.id)
        .then((response) => {
          this.solicitacao = response.data;
          return this.getMunicipios();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getMunicipios() {
      return SolicitacaoService.getMunicipios(this.id)
        .then(({ data }) => {
          this.municipios = data;
        });
    },
    update() {
      this.getSolicitacao();
    },
  },
  created() {
    this.getSolicitacao();
  },
  components: {
    pxCotacaoConjuntaDetalhesHeader: CotacaoConjuntaDetalhesHeader,
    pxCotacaoConjuntaDetalhesProdutos: CotacaoConjuntaDetalhesProdutos,
    pxCotacaoConjuntaNegociacao: CotacaoConjuntaNegociacao,
  },
};
</script>
